// resources/js/Pages/HallOfFame/components/StartMessageModal.jsx
import React, { useState, useEffect } from 'react';

export default function StartMessageModal({ show, onHide, recipientName, endpoint, isLoggedIn }) {
    const [messageBody, setMessageBody] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [error, setError] = useState(null);

    // Reset form when modal closes
    useEffect(() => {
        if (!show) {
            setMessageBody('');
            setError(null);
        }
    }, [show]);

    const handleSendMessage = async () => {
        // Validate message
        if (!messageBody.trim()) {
            setError('Please enter a message.');
            return;
        }

        // Get CSRF token
        const csrfToken = document.querySelector('meta[name="csrf-token"]');
        if (!csrfToken) {
            setError('Security token not found. Please refresh the page.');
            return;
        }

        // Disable button and start sending
        setIsSending(true);
        setError(null);

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken.getAttribute('content'),
                    'Accept': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ body: messageBody }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to send message');
            }

            // Success
            alert('Message Sent!'); // TODO: Replace with toast notification
            setMessageBody('');
            onHide();
        } catch (err) {
            setError('Failed to send message: ' + err.message);
        } finally {
            setIsSending(false);
        }
    };

    // Don't render if not shown
    if (!show) return null;

    return (
        <>
            {/* Bootstrap Modal Backdrop */}
            <div 
                className="modal-backdrop fade show" 
                onClick={onHide}
                style={{ zIndex: 1050 }}
            />
            
            {/* Bootstrap Modal */}
            <div 
                className="modal fade show" 
                id="startMessageModal" 
                tabIndex="-1" 
                aria-labelledby="startMessageModalLabel" 
                aria-hidden="false"
                style={{ display: 'block', zIndex: 1055 }}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="startMessageModalLabel">Send Message</h5>
                            <button 
                                type="button" 
                                className="btn-close" 
                                onClick={onHide}
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <p>To: <strong>{recipientName}</strong></p>
                            
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}
                            
                            <div className="mb-3">
                                <label htmlFor="modal-message-body" className="form-label">Message</label>
                                <textarea 
                                    className="form-control" 
                                    id="modal-message-body" 
                                    rows="4" 
                                    placeholder="Type your message..."
                                    value={messageBody}
                                    onChange={(e) => setMessageBody(e.target.value)}
                                    disabled={isSending}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                onClick={onHide}
                                disabled={isSending}
                            >
                                Close
                            </button>
                            <button 
                                type="button" 
                                className="btn btn-primary" 
                                onClick={handleSendMessage}
                                disabled={isSending}
                            >
                                {isSending ? 'Sending...' : 'Send Message'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
